import { getPersonalMenuScriptSrc } from './getPersonalMenuScriptSrc';
export const includePersonalMenuScript = () => {
  const personalMenuSrc = getPersonalMenuScriptSrc();
  // This is for the case where only does not include the script by its own
  if (personalMenuSrc) {
    const el = document.createElement('script');
    el.setAttribute('src', personalMenuSrc);
    document.head.append(el);
  }
};